import { isProfileLoadedFromApi, checkNavItemAccess } from './featureFlagGuardUtils';

/**
 * Testable function for chukkers route access.
 * Returns '/lms' to redirect, or undefined to allow access.
 */
export const checkChukkersAccess = (): string | undefined => {
   return checkNavItemAccess('chukkers');
};

/**
 * Middleware to protect Chukkers route when nav item is hidden.
 */
export default defineNuxtRouteMiddleware(() => {
   if (!isProfileLoadedFromApi()) {
      return;
   }

   const redirect = checkChukkersAccess();

   if (redirect) {
      return navigateTo(redirect);
   }
});
